import { Component } from "solid-js";
import DefaultModal from "../elements/DefaultModal";
import HeaderModal from "../elements/HeaderModal";
import TypeConnectCard from "../elements/TypeConnectCard";

// import assets
import DomainImg from "../assets/world_lock.svg";
import SubdomainImg from "../assets/web_search.svg";

import Styles from "bundle-text:../styles/_typeConnectModal.scss";
import { translations as t } from "../../../services/context";

interface ModalProps {
  show: boolean;
  onClose: () => void;
  onBack?: () => void;
  onSelect?: (type: string) => void;
}

const TypeConnectModal: Component<ModalProps> = (props) => {
  return (
    <>
      <style>{Styles}</style>
      <DefaultModal show={props.show}>
        <HeaderModal
          title={t["dns_choose_connection"]}
          onBack={props.onBack}
          onClose={props.onClose}
        />

        <div className="type-connect-modal">
          <TypeConnectCard
            title={t["dns_connect_domain"]}
            subtitle={t["dns_type_connection_domain"]}
            img={DomainImg}
            onSelect={() => props.onSelect("domain")}
          />
          <TypeConnectCard
            title={t["dns_connect_subdomain"]}
            subtitle={t["dns_type_connection_subdomain"]}
            img={SubdomainImg}
            onSelect={() => props.onSelect("subdomain")}
          />
        </div>
      </DefaultModal>
    </>
  );
};
export default TypeConnectModal;
